import React from "react";

const BASE_WIDTH = 40;
const BASE_HEIGHT = 40;

interface OwnProps {
  width?: number;
  height?: number;
  color?: string;
}
export default function RotateRightIcon(props: OwnProps) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 33H10C9.46973 32.9995 8.96133 32.7886 8.58637 32.4136C8.21141 32.0387 8.00053 31.5303 8 31V19C8.00053 18.4697 8.21141 17.9613 8.58637 17.5864C8.96133 17.2114 9.46973 17.0005 10 17H22C22.5303 17.0005 23.0387 17.2114 23.4136 17.5864C23.7886 17.9613 23.9995 18.4697 24 19V31C23.9995 31.5303 23.7886 32.0387 23.4136 32.4136C23.0387 32.7886 22.5303 32.9995 22 33ZM10 19V31H22.001L22 19H10Z"
        fill="#4D4D4D"
      />
      <path
        d="M36 18L34.59 16.59L32 19.17V14C31.9979 12.1441 31.2597 10.3649 29.9474 9.05259C28.6351 7.7403 26.8559 7.00212 25 7H20V9H25C26.3256 9.00159 27.5964 9.52888 28.5338 10.4662C29.4711 11.4036 29.9984 12.6744 30 14V19.17L27.41 16.59L26 18L31 23L36 18Z"
        fill="#4D4D4D"
      />
    </svg>
  );
}
